<div
  class="select-radio"
  [ngClass]="{
    'select-radio--disabled': readonly || disabled,
    'select-radio--error': error
  }"
>
  <ng-container *ngIf="label && options.length <= 2">
    <label
      class="select-radio__label"
    >{{ label }}{{required ? '*' : ''}}</label>
  </ng-container>
  <div class="row">
    <ng-container *ngIf="options.length <= 2; else select">
      <ng-container *ngFor="let option of options; let index = index">
        <div
          class="col-xs-24 col-gutter-lr"
          [ngClass]="{
            'col-sm-3': options.length <= 2 && view !== 'agent',
            'col-sm-4': options.length > 2 || view === 'agent'
          }"
          style="padding-right: 130px;"
        >
          <mfp-radio-button
            [view]="view"
            [idRadio]="index + name"
            [id]="name"
            [name]="name"
            [label]="option.key"
            [labelSize]="labelSize"
            [valueRadio]="option.value"
            [disabled]="readonly || disabled"
            [(ngModel)]="value"
          ></mfp-radio-button>
        </div>
      </ng-container>
    </ng-container>

    <ng-template #select>
      <div
      class="col-xs-24"
      [ngClass]="{
        'col-sm-12': view === 'agent' && !full,
        'col-sm-24': view === 'agent' && full,
        'col-no-gutter': view === 'agent',
        'col-sm-4': view === 'client',
        'col-gutter-lr': view === 'client'
      }"
      >
        <mfp-select
          [view]="view"
          [color]="color"
          [id]="name"
          [name]="name"
          [label]="label"
          [placeholder]="placeholder"
          [options]="options"
          [required]="required"
          [readonly]="readonly"
          [disabled]="disabled"
          [success]="success"
          [error]="error"
          [(ngModel)]="value"
        ></mfp-select>
      </div>
    </ng-template>
  </div>
  <ng-container *ngIf="helper">
    <p class="select-radio__helper">{{ helper }}</p>
  </ng-container>
</div>
